import * as i0 from '@angular/core';
import { Injectable, Component, Inject, Optional, EventEmitter, Injector, TemplateRef, Directive, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { Subject, BehaviorSubject, takeUntil, concatAll, take, timer, map, combineLatest, filter, from, tap, Observable, skip, distinctUntilChanged, Subscription } from 'rxjs';
import { style, trigger, transition, animate } from '@angular/animations';
function NgBusyComponent_ng_container_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("@flyInOut", undefined)("@.disabled", ctx_r1.disableAnimation);
  }
}
function NgBusyComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, NgBusyComponent_ng_container_0_div_3_Template, 1, 2, "div", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r0.wrapperClass);
    i0.ɵɵproperty("@flyInOut", undefined)("@.disabled", ctx_r0.disableAnimation);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showBackdrop);
  }
}
const _c0 = ["*"];
class InstanceConfigHolderService {
  constructor() {}
}
InstanceConfigHolderService.ɵfac = function InstanceConfigHolderService_Factory(t) {
  return new (t || InstanceConfigHolderService)();
};
InstanceConfigHolderService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
  token: InstanceConfigHolderService,
  factory: InstanceConfigHolderService.ɵfac,
  providedIn: 'any'
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InstanceConfigHolderService, [{
    type: Injectable,
    args: [{
      providedIn: 'any'
    }]
  }], function () {
    return [];
  }, null);
})();
class BusyConfig {
  constructor(config = {}) {
    for (const option of Object.keys(BUSY_CONFIG_DEFAULTS)) {
      this[option] = config[option] !== undefined ? config[option] : BUSY_CONFIG_DEFAULTS[option];
    }
  }
}
class DefaultBusyComponent {
  constructor(instanceConfigHolder) {
    this.instanceConfigHolder = instanceConfigHolder;
  }
  get message() {
    return this.instanceConfigHolder.config.message;
  }
}
DefaultBusyComponent.ɵfac = function DefaultBusyComponent_Factory(t) {
  return new (t || DefaultBusyComponent)(i0.ɵɵdirectiveInject('instanceConfigHolder'));
};
DefaultBusyComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: DefaultBusyComponent,
  selectors: [["default-busy"]],
  decls: 17,
  vars: 1,
  consts: [[1, "ng-busy-default-wrapper"], [1, "ng-busy-default-sign"], [1, "ng-busy-default-spinner"], [1, "bar1"], [1, "bar2"], [1, "bar3"], [1, "bar4"], [1, "bar5"], [1, "bar6"], [1, "bar7"], [1, "bar8"], [1, "bar9"], [1, "bar10"], [1, "bar11"], [1, "bar12"], [1, "ng-busy-default-text"]],
  template: function DefaultBusyComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
      i0.ɵɵelement(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "div", 7)(8, "div", 8)(9, "div", 9)(10, "div", 10)(11, "div", 11)(12, "div", 12)(13, "div", 13)(14, "div", 14);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(15, "div", 15);
      i0.ɵɵtext(16);
      i0.ɵɵelementEnd()()();
    }
    if (rf & 2) {
      i0.ɵɵadvance(16);
      i0.ɵɵtextInterpolate(ctx.message);
    }
  },
  encapsulation: 2
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DefaultBusyComponent, [{
    type: Component,
    args: [{
      selector: 'default-busy',
      template: `
      <div class="ng-busy-default-wrapper">
          <div class="ng-busy-default-sign">
              <div class="ng-busy-default-spinner">
                  <div class="bar1"></div>
                  <div class="bar2"></div>
                  <div class="bar3"></div>
                  <div class="bar4"></div>
                  <div class="bar5"></div>
                  <div class="bar6"></div>
                  <div class="bar7"></div>
                  <div class="bar8"></div>
                  <div class="bar9"></div>
                  <div class="bar10"></div>
                  <div class="bar11"></div>
                  <div class="bar12"></div>
              </div>
              <div class="ng-busy-default-text">{{message}}</div>
          </div>
      </div>
  `
    }]
  }], function () {
    return [{
      type: InstanceConfigHolderService,
      decorators: [{
        type: Inject,
        args: ['instanceConfigHolder']
      }]
    }];
  }, null);
})();
const BUSY_CONFIG_DEFAULTS = {
  template: DefaultBusyComponent,
  templateNgStyle: {},
  delay: 0,
  minDuration: 0,
  backdrop: true,
  message: 'Please wait...',
  wrapperClass: 'ng-busy',
  disableAnimation: false
};
function isPromise(value) {
  return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
class BusyTrackerService {
  constructor() {
    this.busyQueue = [];
    this.operations = new Subject();
    this.busyDone = new Subject();
    this.destroyIndicator = new Subject();
    this.checkSubject = new Subject();
    this.processingIndicator = new BehaviorSubject(false);
    this.active = new BehaviorSubject(false);
    this.reset();
    this.operations.pipe(takeUntil(this.destroyIndicator), concatAll()).subscribe();
    this.checkSubject.pipe(takeUntil(this.destroyIndicator)).subscribe(options => {
      this.processingIndicator.pipe(take(1)).subscribe(isProcessing => {
        if (isProcessing === false && this.isBusy) {
          this.processingIndicator.next(true);
          timer(options.delay || 0).pipe(map(() => this.isBusy)).subscribe(stillBusy => {
            if (stillBusy) {
              this.active.next(stillBusy);
              combineLatest([this.busyDone, timer(options.minDuration || 0)]).pipe(takeUntil(this.active.pipe(filter(a => a === false)))).subscribe(() => {
                if (!this.isBusy) {
                  this.reset();
                }
              });
            } else {
              this.processingIndicator.next(false);
            }
          });
        }
      });
    });
  }
  get isActive() {
    return this.active.value;
  }
  get busyList() {
    return [...this.busyQueue];
  }
  get isBusy() {
    return this.busyQueue.filter(b => !b.closed).length > 0;
  }
  load(options) {
    this.operations.next(from(options.busyList).pipe(filter(busy => busy !== null && busy !== undefined && !busy.hasOwnProperty('__loaded_mark_by_ng_busy')), tap(busy => Object.defineProperty(busy, '__loaded_mark_by_ng_busy', {
      value: true,
      configurable: false,
      enumerable: false,
      writable: false
    })), map(busy => isPromise(busy) ? from(busy).subscribe() : busy), tap(subscription => this.appendToQueue(subscription))));
    this.checkSubject.next(options);
  }
  updateActiveStatus() {
    this.busyQueue = this.busyQueue.filter(cur => cur && !cur.closed);
    if (this.busyQueue.length === 0) {
      this.busyDone.next(true);
    }
  }
  reset() {
    this.active.next(false);
    this.busyQueue = [];
    this.processingIndicator.next(false);
  }
  appendToQueue(busy) {
    this.busyQueue.push(busy);
    busy.add(() => {
      this.operations.next(new Observable(subscriber => {
        this.updateActiveStatus();
        subscriber.complete();
      }));
    });
  }
  ngOnDestroy() {
    this.destroyIndicator.next(null);
  }
}
BusyTrackerService.ɵfac = function BusyTrackerService_Factory(t) {
  return new (t || BusyTrackerService)();
};
BusyTrackerService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
  token: BusyTrackerService,
  factory: BusyTrackerService.ɵfac,
  providedIn: 'any'
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BusyTrackerService, [{
    type: Injectable,
    args: [{
      providedIn: 'any'
    }]
  }], function () {
    return [];
  }, null);
})();
class BusyConfigHolderService {
  constructor(config) {
    this.config = Object.assign({}, BUSY_CONFIG_DEFAULTS, config || new BusyConfig());
  }
}
BusyConfigHolderService.ɵfac = function BusyConfigHolderService_Factory(t) {
  return new (t || BusyConfigHolderService)(i0.ɵɵinject(BusyConfig, 8));
};
BusyConfigHolderService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
  token: BusyConfigHolderService,
  factory: BusyConfigHolderService.ɵfac,
  providedIn: 'root'
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BusyConfigHolderService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], function () {
    return [{
      type: BusyConfig,
      decorators: [{
        type: Optional
      }]
    }];
  }, null);
})();
const inactiveStyle = style({
  opacity: 0,
  transform: 'translateY(-40px)'
});
const timing = '.3s ease';
class NgBusyComponent {
  constructor(instanceConfigHolder, busyEmitter, vcr, cdr) {
    this.instanceConfigHolder = instanceConfigHolder;
    this.busyEmitter = busyEmitter;
    this.vcr = vcr;
    this.cdr = cdr;
    this.disableAnimation = false;
    this.showBackdrop = true;
    this.destroyIndicator = new Subject();
    this.show = new Subject();
    this.show.pipe(takeUntil(this.destroyIndicator)).subscribe(() => {
      this.cdr.detectChanges();
    });
    this.busyEmitter.pipe(takeUntil(this.destroyIndicator)).subscribe(isActive => {
      if (isActive === true) {
        const config = this.instanceConfigHolder.config;
        this.wrapperClass = config.wrapperClass;
        this.showBackdrop = config.backdrop;
        this.disableAnimation = config.disableAnimation;
      }
      this.show.next(isActive);
    });
  }
  ngOnDestroy() {
    this.destroyIndicator.next(null);
  }
}
NgBusyComponent.ɵfac = function NgBusyComponent_Factory(t) {
  return new (t || NgBusyComponent)(i0.ɵɵdirectiveInject('instanceConfigHolder'), i0.ɵɵdirectiveInject('busyEmitter'), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
};
NgBusyComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: NgBusyComponent,
  selectors: [["lib-ng-busy"]],
  ngContentSelectors: _c0,
  decls: 2,
  vars: 3,
  consts: [[4, "ngIf"], ["class", "ng-busy-backdrop", 4, "ngIf"], [1, "ng-busy-backdrop"]],
  template: function NgBusyComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵtemplate(0, NgBusyComponent_ng_container_0_Template, 4, 5, "ng-container", 0);
      i0.ɵɵpipe(1, "async");
    }
    if (rf & 2) {
      i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.show));
    }
  },
  dependencies: [i1.NgIf, i1.AsyncPipe],
  data: {
    animation: [trigger('flyInOut', [transition('void => *', [inactiveStyle, animate(timing)]), transition('* => void', [animate(timing, inactiveStyle)])])]
  }
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgBusyComponent, [{
    type: Component,
    args: [{
      selector: 'lib-ng-busy',
      animations: [trigger('flyInOut', [transition('void => *', [inactiveStyle, animate(timing)]), transition('* => void', [animate(timing, inactiveStyle)])])],
      template: "<ng-container *ngIf=\"show | async\">\r\n  <div [class]=\"wrapperClass\" @flyInOut [@.disabled]=\"disableAnimation\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n  <div class=\"ng-busy-backdrop\" @flyInOut [@.disabled]=\"disableAnimation\" *ngIf=\"showBackdrop\">\r\n  </div>\r\n</ng-container>\r\n"
    }]
  }], function () {
    return [{
      type: InstanceConfigHolderService,
      decorators: [{
        type: Inject,
        args: ['instanceConfigHolder']
      }]
    }, {
      type: i0.EventEmitter,
      decorators: [{
        type: Inject,
        args: ['busyEmitter']
      }]
    }, {
      type: i0.ViewContainerRef
    }, {
      type: i0.ChangeDetectorRef
    }];
  }, null);
})();
class NgBusyDirective {
  constructor(configHolder, instanceConfigHolder, tracker, cdr, vcr, renderer, injector) {
    this.configHolder = configHolder;
    this.instanceConfigHolder = instanceConfigHolder;
    this.tracker = tracker;
    this.cdr = cdr;
    this.vcr = vcr;
    this.renderer = renderer;
    this.injector = injector;
    this.busyStart = new EventEmitter();
    this.busyStop = new EventEmitter();
    this.destroyIndicator = new Subject();
    this.configLoader = new Subject();
    this.busyEmitter = new EventEmitter();
    tracker.active.pipe(skip(1), takeUntil(this.destroyIndicator), distinctUntilChanged()).subscribe(status => {
      if (status === true) {
        this.recreateBusyIfNecessary();
        this.busyStart.emit();
      } else {
        this.busyStop.emit();
      }
      this.busyEmitter.next(status);
    });
    this.configLoader.pipe(takeUntil(this.destroyIndicator)).subscribe(config => {
      const busyList = config.busy.filter(b => b?.['closed'] !== true && !b?.hasOwnProperty?.('__loaded_mark_by_ng_busy'));
      this.optionsNorm = config;
      this.instanceConfigHolder.config = this.optionsNorm;
      if (busyList.length > 0) {
        this.tracker.load({
          busyList,
          delay: this.optionsNorm.delay,
          minDuration: this.optionsNorm.minDuration
        });
      }
    });
  }
  set options(op) {
    this._option = op;
  }
  get options() {
    return this._option;
  }
  get trackerService() {
    return this.tracker;
  }
  ngDoCheck() {
    this.configLoader.next(this.normalizeOptions(this.options));
  }
  ngOnDestroy() {
    this.destroyIndicator.next(null);
  }
  recreateBusyIfNecessary() {
    this.destroyComponents();
    this.template = this.optionsNorm.template;
    this.templateNgStyle = this.optionsNorm.templateNgStyle;
    this.createBusy();
  }
  normalizeOptions(options) {
    if (!options) {
      options = {
        busy: []
      };
    } else if (Array.isArray(options)) {
      options = {
        busy: options
      };
    } else if (isPromise(options) || options instanceof Subscription) {
      options = {
        busy: [options]
      };
    }
    options = Object.assign({}, this.configHolder.config, options);
    if (!Array.isArray(options.busy)) {
      options.busy = [options.busy];
    }
    return options;
  }
  destroyComponents() {
    if (this.busyRef) {
      this.busyRef.destroy();
    }
  }
  createBusy() {
    const injector = Injector.create({
      providers: [{
        provide: 'instanceConfigHolder',
        useValue: this.instanceConfigHolder
      }, {
        provide: 'busyEmitter',
        useValue: this.busyEmitter
      }],
      parent: this.injector
    });
    this.template = this.optionsNorm.template;
    this.busyRef = this.vcr.createComponent(NgBusyComponent, {
      injector,
      projectableNodes: this.generateNgContent(injector)
    });
    this.busyRef.onDestroy(() => {
      this.busyRef.instance.ngOnDestroy();
    });
    this.cdr.markForCheck();
    this.busyRef.hostView.detectChanges();
  }
  generateNgContent(injector) {
    if (typeof this.template === 'string') {
      const element = this.renderer.createText(this.template);
      return [[element]];
    }
    if (this.template instanceof TemplateRef) {
      const context = {};
      const viewRef = this.template.createEmbeddedView(context);
      return [viewRef.rootNodes];
    }
    if (typeof this.template === 'function') {
      const factory = this.vcr.createComponent(this.template, {
        injector
      });
      factory.onDestroy(() => {
        factory?.instance?.ngOnDestroy?.();
      });
      factory.changeDetectorRef.markForCheck();
      return [[factory.location.nativeElement]];
    }
    return [[]];
  }
}
NgBusyDirective.ɵfac = function NgBusyDirective_Factory(t) {
  return new (t || NgBusyDirective)(i0.ɵɵdirectiveInject(BusyConfigHolderService), i0.ɵɵdirectiveInject(InstanceConfigHolderService), i0.ɵɵdirectiveInject(BusyTrackerService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.Injector));
};
NgBusyDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
  type: NgBusyDirective,
  selectors: [["", "ngBusy", ""]],
  inputs: {
    options: [i0.ɵɵInputFlags.None, "ngBusy", "options"]
  },
  outputs: {
    busyStart: "busyStart",
    busyStop: "busyStop"
  },
  exportAs: ["ngBusy"],
  features: [i0.ɵɵProvidersFeature([BusyTrackerService, InstanceConfigHolderService])]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgBusyDirective, [{
    type: Directive,
    args: [{
      selector: '[ngBusy]',
      providers: [BusyTrackerService, InstanceConfigHolderService],
      exportAs: 'ngBusy'
    }]
  }], function () {
    return [{
      type: BusyConfigHolderService
    }, {
      type: InstanceConfigHolderService
    }, {
      type: BusyTrackerService
    }, {
      type: i0.ChangeDetectorRef
    }, {
      type: i0.ViewContainerRef
    }, {
      type: i0.Renderer2
    }, {
      type: i0.Injector
    }];
  }, {
    options: [{
      type: Input,
      args: ['ngBusy']
    }],
    busyStart: [{
      type: Output
    }],
    busyStop: [{
      type: Output
    }]
  });
})();
class NgBusyModule {
  static forRoot(config) {
    return {
      ngModule: NgBusyModule,
      providers: [{
        provide: BusyConfig,
        useValue: config
      }]
    };
  }
}
NgBusyModule.ɵfac = function NgBusyModule_Factory(t) {
  return new (t || NgBusyModule)();
};
NgBusyModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
  type: NgBusyModule
});
NgBusyModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
  providers: [BusyConfigHolderService, BusyTrackerService],
  imports: [CommonModule]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgBusyModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [DefaultBusyComponent, NgBusyDirective, NgBusyComponent],
      providers: [BusyConfigHolderService, BusyTrackerService],
      exports: [NgBusyDirective]
    }]
  }], null, null);
})();

/*
 * Public API Surface of ng-busy
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BUSY_CONFIG_DEFAULTS, BusyConfig, BusyTrackerService, DefaultBusyComponent, InstanceConfigHolderService, NgBusyComponent, NgBusyDirective, NgBusyModule, isPromise };
